import React from 'react';
import './LegalPage.css';

const AboutUs = () => {
  return (
    <div className="legal-page about-page">
      <div className="container">
        <h1>About Jajoga</h1>
        <p className="lead-text">
          We're on a mission to help salon and medspa owners see what's actually happening in their business.
        </p>

        <section>
          <h2>The Problem We're Solving</h2>
          <p>
            Most salons don't have a growth problem. They have a visibility problem.
          </p>
          <p>
            Owners work long hours, their teams are busy, but margins feel thin. Decisions about staffing, pricing, and expansion all feel like guesses because the data exists but the answers don't.
          </p>
          <p>
            Jajoga removes the guesswork.
          </p>
        </section>

        <section>
          <h2>What We Believe</h2>
          <ul className="beliefs-list">
            <li>
              <strong>AI doesn't run your salon. Insight does.</strong><br />
              AI tools reduce interruptions, but without measurement, they're just noise. We connect AI-driven interactions to real outcomes.
            </li>
            <li>
              <strong>Clarity leads to confidence.</strong><br />
              When you can see demand patterns, staffing efficiency, and revenue drivers clearly, decisions become obvious.
            </li>
            <li>
              <strong>Simplicity over complexity.</strong><br />
              No bloated dashboards. No vanity metrics. Just insight owners actually use.
            </li>
          </ul>
        </section>

        <section>
          <h2>Who We Serve</h2>
          <p>Jajoga is built for:</p>
          <ul>
            <li>Salon and medspa owners who want clarity, not more reports</li>
            <li>Growing or multi-location businesses that need visibility across all locations</li>
            <li>Teams tired of spreadsheet chaos and disconnected systems</li>
          </ul>
        </section>

        <section>
          <h2>How We're Different</h2>
          <p>
            We don't just aggregate data. We connect bookings, calls, payments, and operations to show you where money leaks, where opportunity lives, and what decisions will actually move your business forward.
          </p>
          <p>
            Other platforms give you data. Jajoga gives you clarity.
          </p>
        </section>

        <section>
          <h2>Our Commitment</h2>
          <p>
            We're committed to building software that salon owners actually want to use. That means:
          </p>
          <ul>
            <li>Working with your existing booking system, not replacing it</li>
            <li>Showing patterns in your first week, not months later</li>
            <li>No technical setup or data migration headaches</li>
            <li>Support from people who understand your business</li>
          </ul>
        </section>

        <section>
          <h2>Get In Touch</h2>
          <p>
            Have questions? Want to see how Jajoga works for your salon?
          </p>
          <p>
            <strong>Email:</strong> hello@jajoga.com<br />
            <strong>Phone:</strong> (435) 414-6100
          </p>
        </section>
      </div>
    </div>
  );
};

export default AboutUs;
